/* eslint-disable @typescript-eslint/no-explicit-any */
import { acReferenceDataTypes } from '../acReduxExports';
import hwAxios from '../../../rmsReduxStore/api-service/HWAxios';
import cachedAPI from '../api-service/CachedAPIs';

const url = process.env.REACT_APP_SERVER_BASE_URL_AC;

export const fetchAcChargerHistoryTypeReferenceData: any =
  (reqParams: any) =>
  async (
    dispatch: (arg0: Partial<AcReferenceDataAction>) => void,
  ): Promise<void> => {
    try {
      const response = await hwAxios.get(
        url + `/ref/trend-type?chargerId=${reqParams?.chargerId}`,
      );

      const reduxReponse = response?.data?.data?.data?.historyTypes?.map(
        (data) => {
          return {
            id: data?.id,
            value: data?.name,
            label: data?.name,
            name: data?.name,
            defaultOption: data?.defaultOption,
            statType: data?.statType?.map((statData) => ({
              id: statData?.id,
              value: statData?.name,
              label: statData?.name,
              name: statData?.name,
              defaultOption: statData?.defaultOption,
            })),
            connectorType: data?.connectorType?.map((statData) => ({
              id: statData?.id,
              value: statData?.name,
              label: statData?.name,
              name: statData?.name,
              defaultOption: statData?.defaultOption,
            })),
          };
        },
      );
      const action: Partial<AcReferenceDataAction> = {
        type: acReferenceDataTypes.FETCH_AC_HISTORY_TYPE_REFERENCE_DATA,
        chargerHistoryTypeReferenceData: reduxReponse,
      };
      dispatch(action);
      return reduxReponse;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };


export const fetchAcAlarmSeverityReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<AcReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/alarm-severity', 30 * 60 * 60, 'ac-alarm-severity-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<AcReferenceDataAction> = {
            type: acReferenceDataTypes.FETCH_AC_ALARM_SEVERITY_REFERENCE_DATA,
            alarmSeverityReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

  export const fetchAcAlarmTypeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<AcReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/alarm-type', 30 * 60 * 60, 'ac-alarm-type-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
            };
          });
          const action: Partial<AcReferenceDataAction> = {
            type: acReferenceDataTypes.FETCH_AC_ALARM_TYPE_REFERENCE_DATA,
            alarmTypeReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);

        throw error;
      }
    };


  export const fetchAcChargerVisibleIdReferenceData: any =
  (reqBody) =>
    async (
      dispatch: (arg0: Partial<AcReferenceDataAction>) => void
    ): Promise<string> => {
      try {
        const response = await hwAxios.post(url +'/ref/charger-visible-id', reqBody).then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.visibleId,
              name: data?.visibleId,
              customerId: data?.customerId,
            };
          });
          const action: Partial<AcReferenceDataAction> = {
            type: acReferenceDataTypes.FETCH_AC_CHARGER_VISIBLE_ID_REFERENCE_DATA,
            chargerVisibleIdReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse)
        });
        return response;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };


export const fetchAcCustomerReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<AcReferenceDataAction>) => void
    ): Promise<any> => {

      try {
        const response = hwAxios.get(url + '/ref/customer').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.customerId,
              value: data?.customerId,
              label: data?.customerName,
              name: data?.customerName,
              customerType: data?.customerType
            };
          });

          const action: Partial<AcReferenceDataAction> = {
            type: acReferenceDataTypes.FETCH_AC_CUSTOMER_REFERENCE_DATA,
            acCustomerReferenceData: reduxReponse,
          };
          dispatch(action);

          return JSON.stringify(reduxReponse);

        })
        return response
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchAcChargerStationReferenceData: any = () =>
  async (
    dispatch: (arg0: Partial<AcReferenceDataAction>) => void
  ): Promise<string> => {
    try {
      const response = cachedAPI.fetchCacheFunction('/ref/charging-station', 30 * 60 * 60, 'ac-charging-station-data').then((response) => {
        const reduxReponse = response?.data?.data?.map((data) => {
          return {
            id: data?.id,
            value: data?.id,
            label: data?.name + `${data?.dealerCode ? ' - ' + data?.dealerCode: ''}`,
            name: data?.name + + `${data?.dealerCode ? ' - ' + data?.dealerCode: ''}`,
            customerId: data?.customerId
          };
        });

        const action: Partial<AcReferenceDataAction> = {
          type: acReferenceDataTypes.FETCH_AC_CHARGER_STATION_REFERENCE_DATA,
          chargingStationReferenceData: reduxReponse,
        };
        dispatch(action);
        return JSON.stringify(reduxReponse)
      })
      return response
    } catch (error) {
      console.log(error);
      throw error;
    }
  };


  export const fetchAcChargerLocationReferenceData: any = () => async (dispatch: (arg0: Partial<AcReferenceDataAction>) => void): Promise<void> => {
  try {
    cachedAPI.fetchCacheFunction('/ref/location', 30 * 60 * 60, 'ac-charging-location-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data,
          value: data,
          label: data,
          name: data,
        };
      });

      const action: Partial<AcReferenceDataAction> = {
        type: acReferenceDataTypes.FETCH_AC_CHARGER_LOCATION_REFERENCE_DATA,
        acChargerLocationReferenceData: reduxReponse,
      };
      dispatch(action);
    })
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const fetchAcParametersReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<AcReferenceDataAction>) => void
    ): Promise<void> => {

      try {
        cachedAPI.fetchCacheFunction('/ref/params-master', 30 * 60 * 60, 'ac-parameters-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.userName,
              name: data?.userName,
            };
          });

          const action: Partial<AcReferenceDataAction> = {
            type: acReferenceDataTypes.FETCH_AC_PARAMETERS_REFERENCE_DATA,
            parametersReferenceData: reduxReponse,
          };
          dispatch(action);
        })

      } catch (error) {
        console.log(error);

        throw error;
      }
    };

    export const fetchAcChargerProductTypeReferenceData: any = () => async (dispatch: (arg0: Partial<AcReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/product-type', 30 * 60 * 60, 'ac-charger-product-type-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<AcReferenceDataAction> = {
        type: acReferenceDataTypes.FETCH_AC_CHARGER_PRODUCT_TYPE_REFERENCE_DATA,
        chargerProductTypeReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const fetchAcVersionReleasesSoftwarVersionReferenceData: any =
  (reqBody) =>
    async (
      dispatch: (arg0: Partial<AcReferenceDataAction>) => void
    ): Promise<string> => {
      try {
        const res = await cachedAPI.fetchCacheFunction(`/ref/software-version/product-type?productType=${reqBody?.productType}`, 30 * 60 * 60, `ac-version-releases-software-version-data-${reqBody?.productType}`).then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data,
              value: data,
              label: data,
              name: data,
            };
          });
          const action: Partial<AcReferenceDataAction> = {
            type: acReferenceDataTypes.FETCH_AC_VERSION_RELEASES_SOFTWARE_VERSION_REFERENCE_DATA,
            versionReleasesSoftwareVersionReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse);
        });
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

    export const fetchAcSoftwarVersionReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<AcReferenceDataAction>) => void
    ): Promise<any> => {
      try {
        const res = cachedAPI.fetchCacheFunction('/ref/software-version', 30 * 60 * 60, 'ac-software-version-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data,
              value: data,
              label: data,
              name: data,
            };
          });

          const action: Partial<AcReferenceDataAction> = {
            type: acReferenceDataTypes.FETCH_AC_SOFTWARE_VERSION_REFERENCE_DATA,
            softwareVersionReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse)
        });
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };


export const fetchAcRuleAlarmTypeReferenceData: any = () =>
  async (dispatch: (arg0: Partial<AcReferenceDataAction>) => void): Promise<string> => {
    try {
      const response = cachedAPI.fetchCacheFunction('/ref/rule-alarm-type', 30 * 60 * 60, 'ac-rule-alarm-type-data').then((response) => {
        const reduxReponse = response?.data?.data?.map((data) => {
          return {
            id: data?.id,
            severity: data?.severity,
            name: data?.name,
            label: data?.name,
            value: data?.name,
          };
        });
        const action: Partial<AcReferenceDataAction> = {
          type: acReferenceDataTypes.FETCH_AC_RULE_ALARM_TYPE_REFERENCE_DATA,
          ruleAlarmTypeReferenceData: reduxReponse,
        };
        dispatch(action);
        return JSON.stringify(reduxReponse);
      });
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

export const fetchAcAlarmRuleReferenceData: any = () =>
  async (dispatch: (arg0: Partial<AcReferenceDataAction>) => void): Promise<void> => {
    try {
      cachedAPI.fetchCacheFunction('/ref/alarm-rule', 30 * 60 * 60, 'ac-alarm-rule-data').then((response) => {
        const reduxReponse = response?.data?.data?.map((data) => {
          return {
            id: data?.id,
            value: data?.id,
            label: data?.name,
            name: data?.name,
          };
        });
        const action: Partial<AcReferenceDataAction> = {
          type: acReferenceDataTypes.FETCH_AC_ALARM_RULE_REFERENCE_DATA,
          acAlarmRuleReferenceData: reduxReponse,
        };
        dispatch(action);
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

export const fetchAcVersionProductTypeReferenceData: any = () => async (dispatch: (arg0: Partial<AcReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/product-type', 30 * 60 * 60, 'ac-charger-product-type-data').then((response) => {
      const reduxResponse = response?.data?.data?.map((data) => {
        return {
          id: data?.name,
          value: data?.name,
          label: data?.name,
          name: data?.name,
        };
      });
      const action: Partial<AcReferenceDataAction> = {
        type: acReferenceDataTypes.FETCH_AC_VERSION_PRODUCT_TYPE_REFERENCE_DATA,
        versionProductTypeReferenceData: reduxResponse,
      };
      dispatch(action);
      return JSON.stringify(reduxResponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchAcVersionUpgradeSoftwareVersionsReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<AcReferenceDataAction>) => void
    ): Promise<string> => {
      try {
        const res = await cachedAPI.fetchCacheFunction('/ref/sw-version-ftp-url', 30 * 60 * 60, 'sw-version-ftp-url').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data.swVersion,
              value: data.swVersion,
              label: data.swVersion,
              name: data.swVersion,
              ftpUrl: data.ftpUrl,
              productType: data.productType
            };
          });
          const action: Partial<AcReferenceDataAction> = {
            type: acReferenceDataTypes.FETCH_AC_VERSION_UPGRADE_SOFTWARE_VERSION_REFERENCE_DATA,
            versionUpgradeSoftwareVersionReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse);
        });
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };